"use strict";

module.exports = /* @ngInject */ function() {
  var that = this;

  that.title = "OpenFin Launch";

  that.set = function(title) {
    that.title = title;
  };

  that.get = function() {
    return that.title;
  };
};



// WEBPACK FOOTER //
// ./app/presentation/services/windowTitle.js